// config.js
const environments = {
    "development": {
      "url": "https://dev.ecodehub.in",
      "ribbonText": "Development"
    },
    "local": {
      "url": "http://localhost:9000",
      "ribbonText": "Local"
    },
    "demo": {
      "url": "https://ecodehub.in",
      "ribbonText": "Demo"
    }
  };
  
  export default environments;
  